<template>
  <div>
    <div class=" loading" v-if="loading">
      <!-- <img src="../assets/images/load.gif" width="100px"> -->
    </div>
    <div class="realbody" style="margin-bottom: 0px;">
      <div class="container ramsey">
        <div class="row">
          <div class="col-md-2 text-center">
            <img class="signman" src="../../../assets/imgs/singin_man.png"/>
          </div>
          <div class="col-md-8 signinpanel text-center">
            <p class="s_panel_title mplus2p-r spacing5-9 black mgtop10">{{ $t("resetPassword") }}</p>

            <form @submit.prevent="doConfirm" name="form">

              <div class="form-group input text-left" :class="{ invalid: $v.password.$error }"
                   style="margin-top: 20px;">
                <label class="mplus2p-m spacing1-2 black signlabel">{{$t('l_password')}} <span
                  style="color: red;">*</span>
                </label>
               <input style="min-height:50px" :placeholder="$t('passwordPlaceholder')"
                           type="password" class="form-control login_widget"
                           name="password"
                           autofocus
                           v-model="$v.password.$model"
                    />
                    <div class="help-block" v-if="!$v.password.minLength">{{$t('r_input_password_validation')}}</div>
                    <div class="help-block" v-if="!$v.password.req && passwordFocus">{{$t('required_filed')}}</div>
              </div>

              <div class="form-group input text-left" :class="{ invalid: $v.cPassword.$error }"
                   style="margin-top: 20px;">
                <label class="mplus2p-m spacing1-2 black signlabel">{{$t('r_c_password')}} <span
                  style="color: red;">*</span>
                </label>
               <input style="min-height:50px" :placeholder="$t('passwordPlaceholder')"
                           type="password"
                           class="form-control login_widget"
                           name="cpassword"
                           autofocus
                           v-model="$v.cPassword.$model"
                    />
                    <div class="help-block" v-if="!$v.cPassword.sameAsPassword">{{$t('r_c_input_password_validation')}}</div>
                    <div class="help-block" v-if="!$v.cPassword.req && cPasswordFocus">{{$t('required_filed')}}</div>
              </div>

              <div class="form-group" style="margin-top: 40px;">
                <button class="btn bluebtn singinbtns mplus2p-r spacing1-2"
                        style="font-size: 1.125rem; font-weight: bold;">{{$t('setPasswordButton')}}
                </button>
              </div>
            </form>

          </div>
          <div class="col-md-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from "vuelidate";
  import {
    required,
    maxLength,
    email,
    minLength,
    sameAs
  } from "vuelidate/lib/validators";
  import axios from "axios";

  export default {
    mixins: [validationMixin],

    validations: {
      password: {req: required, minLength: minLength(6)},
      cPassword: {req: required,sameAsPassword: sameAs("password")}
    },
    data() {
      return {
        loading: false,
        model: {},
        password: "",
        cPassword: "",
        passwordFocus: false,
        cPasswordFocus: false,
      };
    },
    mounted() {
    },

    methods: {
      doConfirm() {
        this.loading = true;
        const thisVue = this;
        const formData = {
          reset_code: this.$route.params.code,
          password: this.password,
          confirm_password: this.cPassword
        };
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.passwordFocus = true;
          this.cPasswordFocus = true;
          this.loading = false;
          $('html, body').animate({scrollTop:50}, 'slow');
        } else {
          axios
          .post("/reset-password", formData, {
            headers: {"X-localization": localStorage.getItem("lan")}
          })
          .then(res => {
            if (!res.data.success) {
              if (res.data.errors === "message") {
                this.$toaster.error(res.data.errors.message);
              }
              if (res.data.errors) {
                for (var i = 0; i < res.data.errors.length; i++) {
                  this.$toaster.error(res.data.errors[i].message);
                  if (res.data.errors === "message") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "reset_code") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "confirm_password") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "password") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                }
              }
              this.loading = false;
            } else {
              this.loading = false;
              this.$toaster.success(thisVue.$t("success_forgot_password"));
              this.$router.push("/global/signin");
            }
          })
          .catch(() => {
            this.$toaster.error(thisVue.$t("err_network"));
          });

          this.$v.$reset();
          this.cPassword = "";
          this.password = "";
        }
      }
    }
  };
</script>

<style scoped>
  .fb-signin-button {
    /* This is where you control how the button looks. Be creative! */
    cursor: pointer;
    display: inline-block;
    padding: 16px;
    border-radius: 3px;
    width: 100%;
    height: 60px;
    background-color: #4267b2;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;
    outline: none;
    overflow: hidden;
    position: relative;
    vertical-align: middle;
    white-space: nowrap;
    margin: auto;
    box-shadow: 0 2px 4px 0 rgba(49, 79, 147, 0.24),
    0 -2px 4px 0 rgba(49, 79, 147, 0.12);
    border-radius: 6.4px;
  }

  .iconFacebook {
    float: left;
  }

  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .input.inline input {
    width: auto;
  }

  .input input:focus {
    outline: none;
    border: 1px solid #3d7dd8;
    background-color: #eee;
  }

  .input.invalid label {
    color: red;
  }

  .input.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .input select {
    border: 1px solid #ccc;
    font: inherit;
  }

  .slabel_panel {
    position: absolute;
    left: 56px;
  }

  .signin_label {
    font-size: 1.75rem;
    font-weight: bold;
  }

  .signin_label_jp {
    font-size: 1rem;
  }

  .ramsey {
    margin-top: 100px;
  }

  .signinpanel {
    padding: 0px 80px;
    padding-bottom: 60px;
  }

  .fa-facebook {
    float: left;
    font-size: 25px;
    margin-top: 2px;
    margin-left: 50px;
    font-weight: bold;
  }

  .fbsigntext {
    font-size: 1.125rem;
    margin-left: -50px;
    font-weight: bold;
  }

  .singinbtns {
    height: 60px;
    padding: 16px;
    width: 100%;
    margin: auto;
    cursor: pointer;
    box-shadow: 0 2px 4px 0 rgba(49, 79, 147, 0.24),
    0 -2px 4px 0 rgba(49, 79, 147, 0.12);
  }

  .liner {
    height: 50px;
    padding-top: 15px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .halfline {
    width: 40%;
    border: solid 1px #788ca0;
  }

  .login_widget {
    height: 50px;
    background-color: #f0f2f4;
    border-radius: 3.2px;
    border: solid 1px #eef0f0;
  }

  .signlabel {
    font-size: 1rem;
    font-weight: 500;
  }

  .addlinks {
    font-size: 0.875rem;
    font-weight: 500;
  }

  .fa-angle-right {
    font-size: 1.2rem !important;
  }

  .fa-angle-left {
    font-size: 1.2rem !important;
  }

  .signman {
    width: 100%;
    margin-top: 430px;
  }

  @media screen and (max-width: 768px) {
    .fbsigntext {
      margin-left: 0px;
    }

    .fa-facebook {
      margin-left: 0px;
    }

    .signman {
      width: 100px;
      margin-top: 0px;
    }

    .slabel_panel {
      position: unset;
      left: 0;
      margin-top: 110px;
      margin-left: 56px;
    }

    .ramsey {
      margin-top: 0px;
    }
  }

  @media screen and (max-width: 415px) {
    .signinpanel {
      padding: 0px 10px;
      padding-bottom: 60px;
    }
  }
</style>
